import Api from './Api'

export default class MaxAvails {
  public static async getMaxAvails(items: any) {
    const api = new Api()

    return api.post('media_plan/max-avails', { items })
  }
}
